import { render, staticRenderFns } from "./NotificationHelp.vue?vue&type=template&id=160800f1&scoped=true"
import script from "./NotificationHelp.vue?vue&type=script&lang=js"
export * from "./NotificationHelp.vue?vue&type=script&lang=js"
import style0 from "./NotificationHelp.vue?vue&type=style&index=0&id=160800f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160800f1",
  null
  
)

export default component.exports